module.exports = __webpack_public_path__ + "img/picto_plug_on.c4cd8f13.png";